<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isAddDialog=true">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="type" label="回复对象" align="center" width="120px">
                    <template slot-scope="scope">
                        {{scope.row.type == 0?'通用':''}}
                        {{scope.row.type == 1?'回复对象男':''}}
                        {{scope.row.type == 2?'回复对象女':''}}
                    </template>
                </el-table-column>
                <el-table-column prop="key" label="关键词" align="center"></el-table-column>
                <el-table-column prop="replyKey" label="回复关键词" align="center"></el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="160px"></el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="220px"
                align="center"
                >
                <template slot-scope="scope">
                    
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        回复对象性别
                    </div>
                    <div class="value">
                        <el-select v-model="addData.type" placeholder="请选择" size="small">
                            <el-option
                            v-for="item in typeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        关键词
                    </div>
                    <div class="value">
                        <el-input v-model="addData.key" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        回复关键词
                    </div>
                    <div class="value">
                        <el-input v-model="addData.replyKey" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="addFun()">确认</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="新增" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        回复对象性别
                    </div>
                    <div class="value">
                        <el-select v-model="editData.type" placeholder="请选择" size="small">
                            <el-option
                            v-for="item in typeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        关键词
                    </div>
                    <div class="value">
                        <el-input v-model="editData.key" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        回复关键词
                    </div>
                    <div class="value">
                        <el-input v-model="editData.replyKey" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="editFun()">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,
            addData:{
                type:0,
                key:'',
                replyKey:'',
            },
            editData:{},
            totalCount:0,
            tableData:[],

            conditionData:{
                Key:'',
                page:1,
                pageSize:10,
            },
            queryList:[
                {type: "input",label: "查询:",name: "Key"},
            ],
            typeList:[{
                label:'通用',
                value:0
            },{
                label:'男',
                value:1
            },{
                label:'女',
                value:2
            }]
           
        }
    },
    created(){
    },
    mounted(){
        this.loadingData();
    },
    methods:{
        async addFun(){
            let res = await api.AdminMessageAdd(this.addData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });   
                this.isAddDialog = false;
                this.addData = {
                    type:0,
                    key:'',
                    replyKey:'',
                }
                this.loadingData();
            }
        },
        async editFun(){
            let res = await api.AdminMessageUpdate(this.editData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功'
                });   
                this.isUpdateDialog = false;
                this.loadingData();
            }
        },
        deleteTip(item){
            this.$confirm('将删除此动态?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async del(item){
            let res = await api.AdminMessageDelete(item.id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });  
                this.loadingData();
            }
        },
        updateTip(row){
            this.editData = row;
            this.isUpdateDialog = true;
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.AdminMessageQueryList(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                Key:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        
      
        
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    /deep/.table-expand {
        font-size: 0;
    }
    .row{
        display: flex;
    }
    /deep/.table-expand label {
        width: 200px;
        padding-left: 50px;
        color: #99a9bf;
    }
    /deep/.table-expand span {
        color: #222222;
    }
    /deep/.table-expand .btn span{
        color: #409eff;
    }
    /deep/.table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
   
</style>
